// Contact Split about running out of AI assistant tokens (AI chat limit, Creator page suggestions)
export const SPLIT_AI_TOKENS_MAILTO = 'mailto:help@split.co?subject=AI%20Assistant%20Token%20Limit';
